<template>
  <aside class="bg-white w-16 h-screen drop-shadow flex flex-col justify-between">
    <!-- Header Logo -->
    <div class="text-center py-2 border-b border-slate-200">
      <img class="w-14 inline-block cursor-pointer" src="@/assets/trinovati-only-logo.png" alt="Trinovati logo"
        @click="onLogoClick" />
    </div>

    <!-- Menu -->
    <nav class="flex-1 py-2 overflow-y-auto">
      <ExternalMenuItem label="home" icon="fa-solid fa-home fa-fw"
        :tooltip="{ content: 'home', theme: 'tooltip-right', placement: 'right' }" @click.native="home"
        :selected="$route.name === 'Home'" />

      <ExternalMenuItem v-for="(item, i) in routes" :key="i" :label="item.label" :items="item.children"
        :tooltip="{ content: item.label, theme: 'tooltip-right', placement: 'right' }"
        :selected="item.label === $route?.meta?.module" />
    </nav>

    <ExternalMenuItem label="profile" icon="fa-solid fa-cog fa-fw"
      :tooltip="{ content: 'profile', theme: 'tooltip-right', placement: 'right' }" @click.native="profile"
      :selected="$route.name === 'Profile'" />

    <!-- Footer -->
    <footer class="pt-4 border-t border-slate-200 select-none">
      <LanguageDropdown :expanded="false" />
      <ExternalMenuItem label="logout" icon="fa-solid fa-arrow-right-from-bracket fa-fw" :tooltip="{
        content: 'logout',
        theme: 'tooltip-right',
        placement: 'right',
      }" @click.native="logout" />
    </footer>
  </aside>
</template>

<script>
import LanguageDropdown from '@/components/ui/LanguageDropdown.vue'
import ExternalMenuItem from '@/components/sidebar/ExternalMenuItem.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SideBar',
  components: { LanguageDropdown, ExternalMenuItem },
  props: {
    expanded: { type: Boolean, default: false },
    routes: { type: Array, default: () => [] },
  },
  data() {
    return {
      clickCount: 0,
    }
  },
  computed: {
    ...mapGetters('user', ['getIsStaff']),
  },
  methods: {
    home() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    profile() {
      if (this.$route.path !== '/profile') {
        this.$router.push('/profile');
      }
    },
    logout() {
      this.$session.destroy()
      this.$router.push('/login')
    },
    onLogoClick() {
      this.clickCount++;
      if (this.clickCount === 5 && this.getIsStaff) {
        this.clickCount = 0;
        this.$root.$emit("enable-chicken-cursor");
      }
    },
  },
}
</script>

<style lang="scss">
@use '@/assets/styles/sidebar.scss';
</style>
